import { Box, Button, Divider, HorizontalGrid, HorizontalStack, Text } from '@shopify/polaris';
import DropdownFilter from '../Common/DropdownFilter';
import { useContext, useEffect, useState } from 'react';
import { getDeposits } from '../../../services/depositsService';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR } from '../../../context/ToastReducer';
import { handleSearchParams } from '../../../helpers/handleSearchParams';

const defaultStates = [
  { label: 'Abierto', value: 'PENDING' },
  {
    label: 'En tránsito',
    value: 'IN_TRANSIT',
  },
  {
    label: 'Cerrado',
    value: 'CLOSED',
  },
];

const defaultFilters = {
  originId: {
    name: 'Depósito Origen',
    slug: 'originId',
  },
  destinationId: {
    name: 'Depósito Destino',
    slug: 'destinationId',
  },
  states: {
    name: 'Estados',
    slug: 'states',
    options: defaultStates,
  },
};

const FiltersTransfers = ({ onFilterChange, initialFilters }) => {
  const [filters, setFilters] = useState(defaultFilters);
  const currentFilters = {
    s: '',
    states: '',
  };

  const setLabelValue = (inputArray) => inputArray.map((i) => ({ label: i.name, value: i.id }));
  const [, dispatchToast] = useContext(ToastContext);

  useEffect(() => {
    Promise.all([
      getDeposits({ limit: 1000 })
        .then((r) => r.data.data)
        .catch((e) => {
          dispatchToast({ type: SET_ERROR, payload: e.response.data });
          return [];
        }),
      // getInventoriesStates().then((r) => r.data.data),
    ]).then(([deposits]) => {
      const setInitial = (key) => (key in initialFilters ? { value: initialFilters[key] } : {});

      setFilters({
        ...filters,
        originId: {
          ...filters.originId,
          options: setLabelValue([...deposits]),
          ...setInitial('originId'),
        },
        destinationId: {
          ...filters.destinationId,
          options: setLabelValue([...deposits]),
          ...setInitial('destinationId'),
        },
        states: {
          ...filters.states,
          options: defaultStates,
          ...setInitial('states'),
        },
      });
    });
    // eslint-disable-next-line
  }, []);

  const handleFilter = ({ slug, value }) => {
    currentFilters[slug] = value.length ? value : '';
    setFilters((f) => ({
      ...f,
      [slug]: {
        ...f[slug],
        value,
      },
    }));
    onFilterChange({ slug, value });
  };

  const clearFilters = () => {
    const currentFilters = { ...filters };
    Object.keys(defaultFilters).forEach((k) => {
      currentFilters[k].value = null;
    });
    setFilters(currentFilters);
    Object.keys(filters).forEach((k) => handleSearchParams(k, ''));
  };

  return (
    <>
      <HorizontalGrid columns={{ xs: 1, md: '4fr 3fr' }} gap="4">
        <HorizontalStack align="start" gap={4}>
          <Box>
            <Text variant="headingMd" as="h4">
              Depósitos
            </Text>
            <Box border="divider" borderRadius="base" minHeight=".5rem" />
            <HorizontalStack align="start" gap={2}>
              <DropdownFilter
                slug="originId"
                title="Depósito Origen"
                onFilterChange={handleFilter}
                defaultValue={filters.originId?.value ?? ''}
                options={filters.originId?.options ?? []}
              />
              <DropdownFilter
                slug="destinationId"
                title="Depósito Destino"
                onFilterChange={handleFilter}
                defaultValue={filters.destinationId?.value ?? ''}
                options={filters.destinationId?.options ?? []}
              />
            </HorizontalStack>
          </Box>
          <Box>
            <Text variant="headingMd" as="h4">
              Estados
            </Text>
            <Box border="divider" borderRadius="base" minHeight=".5rem" />
            <DropdownFilter
              slug="states"
              title="Estados"
              onFilterChange={handleFilter}
              defaultValue={filters.states?.value ?? ''}
              options={filters.states?.options ?? []}
            />
          </Box>
        </HorizontalStack>
      </HorizontalGrid>
      <Box minHeight=".5rem" />
      <Divider />
      <Box minHeight=".5rem" />

      <HorizontalStack align="end">
        <Button onClick={clearFilters} plain>
          Borrar filtros
        </Button>
      </HorizontalStack>
    </>
  );
};

export default FiltersTransfers;
